/**
 * Composing <Route> in React Router v6
 * https://gist.github.com/mjackson/d54b40a094277b7afdd6b81f51a0393f
 *
 * Upgrading from v5
 * https://reactrouter.com/docs/en/v6/upgrading/v5
 */
import { Routes, Route } from "react-router-dom";

import { Home } from "pages/Home";
import { HomeLogin } from "pages/HomeLogin";
import { Login } from "pages/Auth/Login";
import { NotFound } from "pages/NotFound";
import { PrivateRoute } from "./PrivateRoute";
import { PublicRoute } from "./PublicRoute";
import Faq from "pages/Faq";
import Terms from "pages/Terms";
import Profile from "pages/Profile";
import { Register } from "pages/Auth/Register";
import { ForgotPassword } from "pages/Auth/ForgotPassword";
import { Challenges } from "pages/Challenges";
import Achievements from "pages/Achievements";
import { Contact } from "pages/Contact";
import { Objetivos } from "pages/Objetivos";
import { Premios } from "pages/Premios";
import { Extrato } from "pages/Extrato";
import { Campanha } from "pages/Campanha";
import { ComoGanhar } from "pages/ComoGanhar";
import { Experiencias } from "pages/Experiencias";
import { Convencao } from "pages/Convencao";
import { ChallengesResults } from "pages/ChallengesResults";
import { Resgates } from "pages/Resgates";
import { Aniversario } from "pages/Aniversario57Anos";
import { RetaFinal } from "pages/RetaFinal";
import { QuadroMedalhas } from "pages/QuadroMedalhas";
import { Recordistas } from "pages/Recordistas";
import { MinhasEntregas } from "pages/MinhasEntregas";
import { Sorteio } from "pages/Sorteio";
import { Transparencia } from "pages/Transparencia";
import { useGlobalConfig } from "context/GlobalConfigContext";

export const RouteList = () => {
  const { isMenuItemEnabled } = useGlobalConfig();

  return (
    <Routes>
      <Route
        path="/"
        element={
          <PrivateRoute redirectTo="/login">
            <HomeLogin />
          </PrivateRoute>
        }
      />

      <Route
        path="/inicio"
        element={
          <PrivateRoute redirectTo="/login">
            <Home />
          </PrivateRoute>
        }
      />

      <Route
        path="/perfil"
        element={
          <PrivateRoute redirectTo="/login">
            <Profile />
          </PrivateRoute>
        }
      />

      <Route
        path="/desafios"
        element={
          <PrivateRoute redirectTo="/login">
            {isMenuItemEnabled("desafios") ? <Challenges /> : <NotFound />}
          </PrivateRoute>
        }
      />

      <Route
        path="/desafios/apuracao"
        element={
          <PrivateRoute redirectTo="/login">
            <ChallengesResults />
          </PrivateRoute>
        }
      />

      <Route
        path="/objetivos"
        element={
          <PrivateRoute redirectTo="/login">
            {isMenuItemEnabled("objetivos") ? <Objetivos /> : <NotFound />}
          </PrivateRoute>
        }
      />

      <Route
        path="/premios"
        element={
          <PrivateRoute redirectTo="/login">
            {isMenuItemEnabled("meusCards") ? <Premios /> : <NotFound />}
          </PrivateRoute>
        }
      />

      <Route
        path="/experiencias"
        element={
          <PrivateRoute redirectTo="/login">
            {isMenuItemEnabled("mercadoDeEstrelas") ? (
              <Experiencias />
            ) : (
              <NotFound />
            )}
          </PrivateRoute>
        }
      />

      <Route
        path="/convencao"
        element={
          <PrivateRoute redirectTo="/login">
            {isMenuItemEnabled("convencao") ? <Convencao /> : <NotFound />}
          </PrivateRoute>
        }
      />

      <Route
        path="/extrato"
        element={
          <PrivateRoute redirectTo="/login">
            {isMenuItemEnabled("extrato") ? <Extrato /> : <NotFound />}
          </PrivateRoute>
        }
      />

      <Route
        path="/ganhadores"
        element={
          <PrivateRoute redirectTo="/login">
            {isMenuItemEnabled("ganhadores") ? <Achievements /> : <NotFound />}
          </PrivateRoute>
        }
      />

      <Route
        path="/campanha"
        element={
          <PrivateRoute redirectTo="/login">
            {isMenuItemEnabled("aCampanha") ? <Campanha /> : <NotFound />}
          </PrivateRoute>
        }
      />

      <Route
        path="/reta-final"
        element={
          <PrivateRoute redirectTo="/login">
            {isMenuItemEnabled("retaFinal") ? <RetaFinal /> : <NotFound />}
          </PrivateRoute>
        }
      />

      <Route
        path="/minhas-entregas"
        element={
          <PrivateRoute redirectTo="/login">
            {isMenuItemEnabled("minhasEntregas") ? (
              <MinhasEntregas />
            ) : (
              <NotFound />
            )}
          </PrivateRoute>
        }
      />

      <Route
        path="/sorteios"
        element={
          <PrivateRoute redirectTo="/login">
            {isMenuItemEnabled("sorteio") ? <Sorteio /> : <NotFound />}
          </PrivateRoute>
        }
      />

      <Route
        path="/como-ganhar"
        element={
          <PrivateRoute redirectTo="/login">
            {isMenuItemEnabled("formasDeGanhar") ? (
              <ComoGanhar />
            ) : (
              <NotFound />
            )}
          </PrivateRoute>
        }
      />

      <Route
        path="/transparencia"
        element={
          <PrivateRoute redirectTo="/login">
            <Transparencia />
          </PrivateRoute>
        }
      />

      <Route
        path="/resgates"
        element={
          <PrivateRoute redirectTo="/login">
            {isMenuItemEnabled("resgates") ? <Resgates /> : <NotFound />}
          </PrivateRoute>
        }
      />

      <Route
        path="/aniversario"
        element={
          <PrivateRoute redirectTo="/login">
            {isMenuItemEnabled("aniversarioBrb58") ? (
              <Aniversario />
            ) : (
              <NotFound />
            )}
          </PrivateRoute>
        }
      />

      <Route
        path="/faq"
        element={isMenuItemEnabled("faq") ? <Faq /> : <NotFound />}
      />

      <Route
        path="/regulamento"
        element={isMenuItemEnabled("regulamento") ? <Terms /> : <NotFound />}
      />

      <Route path="/contato" element={<Contact />} />

      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />

      <Route
        path="/register"
        element={
          <PublicRoute>
            <Register />
          </PublicRoute>
        }
      />

      <Route
        path="/forgot-password"
        element={
          <PublicRoute>
            <ForgotPassword />
          </PublicRoute>
        }
      />

      <Route
        path="/quadro-medalhas"
        element={
          <PrivateRoute redirectTo="/login">
            {isMenuItemEnabled("quadroMedalhas") ? (
              <QuadroMedalhas />
            ) : (
              <NotFound />
            )}
          </PrivateRoute>
        }
      />

      <Route
        path="/recordistas"
        element={
          <PrivateRoute redirectTo="/login">
            {isMenuItemEnabled("recordistas") ? <Recordistas /> : <NotFound />}
          </PrivateRoute>
        }
      />

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};
